export default __webpack_public_path__ + "static/media/oc-3.35e9d0fd.png";